
import { useState } from 'react';
import Button from '../../components/button/Button';
import Spinner from '../../components/Spinner/spinner';
import P from '../../components/texts/p/P';
import { downloadClientDocument } from '../../services/ClientService';
import { DOCUMENT_IDS } from '../../utils/Constants';
import Card from '../../components/card/Card';
import Icon from '../../components/icon/Icon';
import { documentData } from '../../types/interfaces';
import { getMimeType } from '../../utils/Utils';
import { useClientTheme } from '../../context/ThemeContext';
interface FilePreviewProps {
  file: documentData | undefined;
  requiredDocumentId: string;
  cuit: string;
}

const FilePreview: React.FC<FilePreviewProps> = ({ title, file, requiredDocumentId, cuit }) => {

  const [isDownloading, setIsDownloading] = useState<boolean>();
  const { clientTheme } = useClientTheme();
  const handleDownloadFile = (filename: string) => {
    setIsDownloading(true);
    downloadClientDocument(cuit, filename).then((response) => {
      if (response.success) {
        const mimeType = getMimeType(filename);
        const fileBlob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(fileBlob);

        if (
          mimeType.startsWith('application/pdf') ||
          mimeType.startsWith('image/')
        ) {
          window.open(url, '_blank');
        } else {
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      }
      setIsDownloading(false);
    });
  };

  return (
    (file?.type === requiredDocumentId ?
      <Card display='flex' height='auto' alignItems='center' gap='16px' width='100%' justifyContent='space-between'>
        <Icon name='done_outline' variant={clientTheme ? 'primary' : 'success'} />
        <Card width='100%'>
          <P withMargin={false} type='2' variant='neutral' align='left'>
            {file?.type ? DOCUMENT_IDS[file?.type] : DOCUMENT_IDS[requiredDocumentId]}
          </P>
        </Card>
        <Card display='flex' justifyContent='center' width='75px'>
          {isDownloading ? (
            <Spinner size='md' variant='primary' />
          ) : (
            <Button variant='secondary' size='md' onClick={() => handleDownloadFile(file.file_name)}>
              <Icon name='view_outline' height={44} variant='neutral' cursor='pointer' />
            </Button>
          )}
        </Card>
      </Card>
      :
      <Card display='flex' height='auto' alignItems='center' gap='16px' width='100%' justifyContent='space-between'>
        <Icon name='cancel_outline' variant='danger' />
        <Card width='100%'>
          <P withMargin={false} type='2' variant='neutral' align='left'>
            {DOCUMENT_IDS[requiredDocumentId]}
          </P>
        </Card>
      </Card>
    )
  );
};

export default FilePreview;